import globals from "./globals";
import $ from "cash-dom";

const component = (function () {
    function fillProportionally(_el, _parent) {
        var elementRatio = _el.clientWidth / _el.clientHeight;
        var parentRatio = _parent.clientWidth / _parent.clientHeight;

        if (elementRatio >= parentRatio) {
            _el.style.width = "100%";
            _el.style.height = "auto";
        } else {
            _el.style.width = "auto";
            _el.style.height = "100%";
        }
    }

    $(window).on("load", function () {
        if ($(".fill-proportionally").length) {
            if (globals.debug) console.log("component-fill-proportionally initialized");
            $(".fill-proportionally").each(function () {
                var el = $(this)[0];
                var parent = $(this).parent()[0];

                fillProportionally(el, parent);
            });

            $(window).on("resize", function () {
                $(".fill-proportionally").each(function () {
                    var el = $(this)[0];
                    var parent = $(this).parent()[0];

                    fillProportionally(el, parent);
                });
            });
        }
    });
})();

export default component;
